/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const PremiumIcon = ({ width = '1em', height = '1em' }) => {
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width={width}
			height={height}
		>
			<style>
				{'.st1{clip-path:url(#SVGID_00000031173264345189216960000006724702220811127216_)}'}
			</style>
			<g id='Group_14769' transform='translate(-140 -719)'>
				<g transform='translate(140 719)'>
					<circle
						id='Ellipse_1289-2'
						cx={12}
						cy={12}
						r={12}
						style={{
							fill: '#fef0f6'
						}}
					/>
				</g>
				<g transform='translate(152.484 731.946)' id='Group_14764'>
					<defs>
						<path id='SVGID_1_' d='M-9.5-6.9h18v12h-18z' />
					</defs>
					<clipPath id='SVGID_00000047745811715607333770000009276083745820395170_'>
						<use
							xlinkHref='#SVGID_1_'
							style={{
								overflow: 'visible'
							}}
						/>
					</clipPath>
					<g
						id='Group_14761'
						style={{
							clipPath: 'url(#SVGID_00000047745811715607333770000009276083745820395170_)'
						}}
					>
						<path
							id='Path_39555'
							d='M-7.3 2.6c-.2-1.6-.5-3.2-.8-4.9 0-.1 0-.2-.2-.2-.6-.1-1-.5-1.1-1 0 0 0-.1-.1-.1v-.6c.1-.3.2-.5.4-.7.4-.5 1.1-.7 1.8-.4.6.3 1 1 .8 1.7 0 .1 0 .2.1.2.4.2.8.5 1.2.7.8.5 1.8.3 2.4-.5.3-.4.7-.8 1-1.2.1-.1.1-.2 0-.2-.3-.5-.3-1.1 0-1.5.4-.7 1.3-.9 2-.5.2.1.4.3.5.5.3.5.3 1.1 0 1.5 0 .1-.1.1 0 .2.5.4.9.9 1.3 1.4.6.7 1.6.8 2.4.3.4-.2.7-.5 1.1-.7.1 0 .1-.1.1-.2-.2-.8.3-1.6 1.1-1.8.3-.1.6-.1.8 0 .6.2 1.1.9 1 1.5-.1.7-.5 1.3-1.2 1.4-.2 0-.2.1-.2.3-.3 1.6-.5 3.2-.8 4.8-.1 0-.1 0-.1-.1 0-.2-.2-.4-.4-.5-.5-.4-1-.7-1.6-.9C3 .8 1.7.6.5.6h-2.2c-.7 0-1.5.1-2.2.3-.8.1-1.7.3-2.4.7-.4.2-.8.6-1 1 .1 0 .1 0 0 0'
							style={{
								fill: '#fec008'
							}}
						/>
						<path
							id='Path_39556'
							d='M-7.3 2.6c.1 0 .1 0 0 0 .2-.5.5-.8.9-1 .8-.4 1.7-.6 2.5-.8.7-.1 1.5-.2 2.2-.3H.5c1.2 0 2.5.2 3.7.6.6.2 1.1.5 1.6.9.2.1.4.3.4.5 0 0 0 .1.1.1 0 .6-.4 1.1-1 1.4-.8.4-1.6.7-2.5.8-2.3.4-4.7.4-7-.1-.7-.1-1.4-.3-2-.7-.2-.1-.4-.2-.6-.4-.3-.2-.5-.6-.5-1m6.7 1.7c.9 0 1.7 0 2.6-.1.8-.1 1.5-.2 2.3-.5.3-.2.7-.3 1-.6.3-.2.2-.4 0-.6l-.1-.1c-.5-.3-1.1-.6-1.7-.7-1-.2-2.1-.4-3.3-.4h-1.6c-.6 0-1.2.1-1.8.2-.8.1-1.6.3-2.4.6-.3.1-.5.2-.7.4-.2.1-.2.3-.1.5l.1.1c.2.2.5.4.7.5 1 .4 2.1.6 3.1.7h1.9'
							style={{
								fill: '#fed44f'
							}}
						/>
						<path
							id='Path_39557'
							d='M-.6 4.3c-.6 0-1.3 0-1.9-.1-1.1-.1-2.1-.3-3.1-.7-.3-.1-.5-.3-.7-.5-.2 0-.2-.3-.1-.4l.1-.1c.2-.2.4-.3.7-.4.8-.3 1.6-.5 2.4-.6.6-.1 1.2-.1 1.8-.2H.2c1.1 0 2.2.2 3.3.4.6.1 1.2.4 1.7.7l.1.1c.3.2.3.4 0 .6-.3.3-.7.5-1 .6-.8.2-1.5.4-2.3.5-.9.1-1.7.1-2.6.1'
							style={{
								fill: '#ffa000'
							}}
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}

export default PremiumIcon
